import { render, staticRenderFns } from "./qPopupTableHeader.vue?vue&type=template&id=4cd57d82&"
import script from "./qPopupTableHeader.vue?vue&type=script&lang=ts&"
export * from "./qPopupTableHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports